module.exports = __webpack_public_path__ + "img/icon_order.acce8159.svg";